<template>
  <div class="committee">
    <div class="font-area" :class="globalTransition">
      <div class="title">
        <p>{{$t('aboutPage.p4.title')}}</p>
      </div>
      <p class="split-line">——</p>
    </div>
    <div class="user">
<div v-for="event in userList" :key="event" class="user-item">
  <img :src='computeSrc(event)' class="img"/>
  <div class="name" :class="globalTransition">{{$t('aboutPage.p4.userInfo.'+event+'.name')}}</div>
  <div class="company" :class="globalTransition">
    {{$t('aboutPage.p4.userInfo.'+event+'.company')}}</div>
</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutBoard',
  data() {
    return {
      userList: ['DrKL', 'ProfPW', 'DrRT', 'MrMjL', 'DrDX', 'MrJsL'],
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  methods: {
    computeSrc(event) {
      // eslint-disable-next-line
      return require(`../../assets/${event}.jpg`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .committee{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    padding:100px 10.5%;
    text-align: center;
  }
  .font-area{
    width: 70%;
    .title{
      font-size: 2rem;
      font-weight: bold;
    }
  }
  .user{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    .user-item{
      width: 30%;
      padding: 3% 1%;
      .img{
        width: 100%;
      }
      .name{
        margin-top: 1rem;
        font-size: 1.4rem;
        font-weight: bold;
      }
      .company{
        margin-top: 1rem;
        font-size: 1rem;
        color: #999;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/aboutPage/committee.vue